import React, { forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';

// AccessibleBox component to handle focus management and accessibility
interface AccessibleBoxProps extends BoxProps {
  tabIndex?: number;
  role?: string;
  ariaLabel?: string;
}

export const AccessibleBox = forwardRef<HTMLDivElement, AccessibleBoxProps>(
  ({ tabIndex = 0, role = 'region', ariaLabel, children, ...props }, ref) => (
    <Box ref={ref} tabIndex={tabIndex} role={role} aria-label={ariaLabel} {...props}>
      {children}
    </Box>
  ),
);
